<template>
  <v-row class="mx-0 flex-grow-0 flex-nowrap" flat>
    <v-btn
      v-text="filename ? truncatedFileName : selectLabel"
      color="primary"
      :loading="loading"
      @click="onOpenInput"
    />
    <v-btn
      v-if="filename"
      class="ml-2"
      icon
      rounded
      color="error"
      :loading="loading"
      @click="onClear"
    >
      <v-icon>
        close
      </v-icon>
    </v-btn>
    <input
      :ref="REFKEY"
      type="file"
      hidden
      :accept="accept"
      @change="onImportChange"
    >
  </v-row>
</template>

<script>
const FILE_NAME_MAX_LENGTH = 20
const REFKEY = 'input'

export default {
  props: {
    accept: {
      type: String,
      default: '*',
    },
    selectLabel: {
      type: String,
      default: 'Select file',
    },
    loading: Boolean,
  },
  data() {
    return {
      filename: '',
      REFKEY,
    }
  },

  computed: {
    truncatedFileName() {
      return this.filename.length > FILE_NAME_MAX_LENGTH
        ? this.filename.slice(0, FILE_NAME_MAX_LENGTH / 2) + '...' + this.filename.slice(FILE_NAME_MAX_LENGTH / 2 * -1)
        : this.filename
    }
  },

  methods: {
    /**
     *
     * @param {Event & {target: HTMLInputElement}} event
     */
     onImportChange(event) {
      if (!event.target.files.length) {
        this.filename = ''
        return
      }

      const file = event.target.files[0]
      this.filename = file.name

      const reader = new FileReader()
      reader.readAsText(file, 'utf-8')
      reader.onload = (event) => {
        this.$emit('file-content', event.target.result)
      }
    },

    onOpenInput() {
      this.$refs[REFKEY].value = null
      this.$refs[REFKEY].click()
    },

    onClear() {
      this.$refs[REFKEY].value = null
      this.$refs[REFKEY].dispatchEvent(new InputEvent('change'))
      this.$emit('clear')
    }
  }
}
</script>
